const TO_ANIMATE_CLASSNAME = 'ag-animate';
const TO_ANIMATE_SELECTOR = `.${TO_ANIMATE_CLASSNAME}`;
const ANIMATION_DATA_KEY = 'agAnimation';
const DEFAULT_ANIMATION = 'fadeIn';
const CAN_RUN = typeof window.IntersectionObserver === 'function';
const STAGGER_DELAY = 0.2;
const $window = $(window);

let $itemsToAnimate = null;

const prepare = () => {
  if (!CAN_RUN) {
    return;
  }

  $itemsToAnimate = $(TO_ANIMATE_SELECTOR);
  $itemsToAnimate.css('opacity', 0);
};

const animate = targets => {
  let staggerIndex = 0;
  targets.forEach(target => {
    const $target = $(target);
    const animation = $target.data(ANIMATION_DATA_KEY) || DEFAULT_ANIMATION;
    const hasNoStagger = $target.data('agAnimationNostagger');

    if (!hasNoStagger) {
      $target.css('animation-delay', staggerIndex * STAGGER_DELAY + 's');
      staggerIndex++;
    }

    $target.on('animationend', () => {
      if ($window.height() >= 1080) {
        $target.removeClass(`animate__animated animate__${animation}`)
      }
    });

    $target
      .css('opacity', '')
      .addClass(`animate__animated animate__${animation}`)
      // .removeClass(TO_ANIMATE_CLASSNAME);
  });
};

const run = () => {
  if (!CAN_RUN) {
    return;
  }

  const intersectionObserver = new IntersectionObserver((entries => {
    const targets = entries.map(entry => {
      if (entry.isIntersecting) {
        // intersectionObserver.unobserve(entry.target);
        return entry.target;
      }
    });

    animate(targets);
  }), {threshold: 0.5});

  $itemsToAnimate.each((i, e) => {
    intersectionObserver.observe(e);
  })
};

const animation = () => {
  prepare();
  run();
};

export default animation;

export {
  prepare,
  run,
};
